export default {
  B202_BCNS: 'B202_BCNS',
  B303_BCNS: 'B303_BCNS',
};
